import { gradientBorderCss, safeGradient } from "@/shared/utils/gradient-css";
import { isGradient } from "@components/color-picker/lib/detect";
import { DESIGN_SYSTEM_SHADOW } from "@library/constants";
import styled, { css } from "styled-components";

export const StyledNarratorContainer = styled.div<{
  $pointsSpacing?: number;
  $firstStepHeight?: number;

  $isForPreview?: boolean;
}>`
  --narrator-step-spacing: ${({ $pointsSpacing }) => $pointsSpacing ?? 350}px;

  .combo-narrator__content {
    padding-top: calc(
      (100vh - var(--narrator-top-offset)) / 2 -
        ${({ $firstStepHeight }) => ($firstStepHeight ?? 0) / 2}px
    ) !important;
    padding-bottom: calc(100vh - var(--narrator-top-offset) / 2) !important;
  }

  ${({ $isForPreview }) =>
    $isForPreview &&
    css`
      .group.pos-0 {
        .elementWrapper:last-child .content > *:last-child {
          margin-bottom: 0 !important;
        }
      }
    `}
`;

export const StyledStep = styled.div<{
  $contentOpacity: number;
  $stepStyle: {
    bgColor?: string;
    borderColor?: string;
    borderWidth?: string;
    borderRadius?: string;
    shadow?: string;
  };
}>`
  .group,
  .emptyGroup {
    opacity: ${({ $contentOpacity }) => $contentOpacity} !important;
    transition: opacity 500ms ease;

    &.pos-0 {
      border-radius: ${({ $stepStyle }) =>
        $stepStyle.borderRadius ?? "8px"} !important;

      ${({ $stepStyle }) => {
        const bgColor = $stepStyle.bgColor ?? "transparent";
        if (isGradient(bgColor)) {
          return css`
            background: ${safeGradient(bgColor) ?? "none"} !important;
          `;
        }
        return css`
          background-color: ${bgColor} !important;
        `;
      }}
      ${({ $stepStyle }) => {
        const shadow =
          DESIGN_SYSTEM_SHADOW[
            $stepStyle.shadow as keyof typeof DESIGN_SYSTEM_SHADOW
          ];
        const defaultShadow =
          "0px 3px 5px rgba(18, 3, 62, 0.1), 0px 0px 1px rgba(18, 3, 62, 0.11)";

        if (
          $stepStyle.shadow === "blur" ||
          (!shadow &&
            $stepStyle.bgColor &&
            !["none", "transparent"].includes($stepStyle.bgColor))
        ) {
          return css`
            box-shadow: ${defaultShadow};
          `;
        }

        return css`
          box-shadow: ${shadow || "none"};
        `;
      }}

      ${({ $stepStyle }) => {
        const borderColor = $stepStyle.borderColor;
        if (!borderColor || borderColor === "none") return "";
        const borderWidth = Number($stepStyle.borderWidth) || 0;
        if (isGradient(borderColor)) {
          return css`
            ${gradientBorderCss(borderColor, borderWidth)}
          `;
        }
        return css`
          border-style: solid;
          border-width: ${borderWidth}px !important;
          border-color: ${borderColor} !important;
        `;
      }}
    }
  }
`;
